// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DeclaredArg, DeclaredArgT, verifyDeclaredArg } from "./declared-arg";
import { Key, KeyT } from "./key";

/**
 * A command the IDL declares, whether or not any control sends it.
 */
export class DeclaredCommand implements flatbuffers.IUnpackableObject<DeclaredCommandT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DeclaredCommand {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDeclaredCommand(
    bb: flatbuffers.ByteBuffer,
    obj?: DeclaredCommand,
  ): DeclaredCommand {
    return (obj || new DeclaredCommand()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDeclaredCommand(
    bb: flatbuffers.ByteBuffer,
    obj?: DeclaredCommand,
  ): DeclaredCommand {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DeclaredCommand()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new Key()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  args(index: number, obj?: DeclaredArg): DeclaredArg | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new DeclaredArg()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  argsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startDeclaredCommand(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addArgs(builder: flatbuffers.Builder, argsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, argsOffset, 0);
  }

  static createArgsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startArgsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endDeclaredCommand(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createDeclaredCommand(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    argsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    DeclaredCommand.startDeclaredCommand(builder);
    DeclaredCommand.addKey(builder, keyOffset);
    DeclaredCommand.addName(builder, nameOffset);
    DeclaredCommand.addArgs(builder, argsOffset);
    return DeclaredCommand.endDeclaredCommand(builder);
  }

  unpack(): DeclaredCommandT {
    return new DeclaredCommandT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.name(),
      this.bb!.createObjList<DeclaredArg, DeclaredArgT>(this.args.bind(this), this.argsLength()),
    );
  }

  unpackTo(_o: DeclaredCommandT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.name = this.name();
    _o.args = this.bb!.createObjList<DeclaredArg, DeclaredArgT>(
      this.args.bind(this),
      this.argsLength(),
    );
  }

  unpackFields(...fields: string[]): DeclaredCommandT {
    const t = new DeclaredCommandT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("args")) {
      t.args = this.bb!.createObjList<DeclaredArg, DeclaredArgT>(
        this.args.bind(this),
        this.argsLength(),
      );
    }
    return t;
  }
}

export class DeclaredCommandT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: KeyT | null = null,
    public name: string | Uint8Array | null = null,
    public args: DeclaredArgT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const args = DeclaredCommand.createArgsVector(
      builder,
      builder.createObjectOffsetList(this.args),
    );

    return DeclaredCommand.createDeclaredCommand(
      builder,
      this.key !== null ? this.key!.pack(builder) : 0,
      name,
      args,
    );
  }

  clone(): DeclaredCommandT {
    const obj = new DeclaredCommandT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.name = this.name;
    obj.args = this.args.map((e) => e.clone());
    return obj;
  }

  equals(other: DeclaredCommandT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.name !== other.name) return false;
    if (this.args.length !== other.args.length) return false;
    for (let i = 0; i < this.args.length; i++) {
      const a = this.args[i];
      const b = other.args[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyDeclaredCommand(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 12);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDeclaredArg);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
